// src/pages/Login.jsx
import { useState, useContext } from "react";
import { UserContext } from "../components/UserContext";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button, Container, Card, Alert } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { apiFetch } from "../utils/csrf";

const Login = () => {
  const { login } = useContext(UserContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await apiFetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: form.email.toLowerCase().trim(),
          password: form.password
        })
      });

      const data = await res.json();

      if (res.ok) {
        login(data.user, data.token);
        navigate("/");
      } else {
        setError(data.error || "Login failed. Please check your credentials.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <Card style={{ width: "100%", maxWidth: "450px" }} className="shadow-lg">
          <Card.Body className="p-5">
            <h1 className="text-center mb-4" style={{ color: "#003366", fontWeight: "700" }}>
              Login to TRvents
            </h1>
            
            {error && <Alert variant="danger">{error}</Alert>}
            
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={{ fontWeight: "600" }}>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                  style={{ padding: "12px", fontSize: "15px" }}
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formPassword">
                <Form.Label style={{ fontWeight: "600" }}>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                  style={{ padding: "12px", fontSize: "15px" }}
                />
                <div className="text-end mt-2">
                  <Link to="/forgot-password" style={{ fontSize: "14px", color: "#003366", textDecoration: "none" }}>
                    Forgot password?
                  </Link>
                </div>
              </Form.Group>

              <Button
                type="submit"
                className="w-100"
                disabled={loading}
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  backgroundColor: "#003366",
                  border: "none",
                  borderRadius: "8px"
                }}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <p className="mb-0" style={{ color: "#666" }}>
                Don't have an account? <Link to="/register" style={{ color: "#003366", fontWeight: "600", textDecoration: "none" }}>Sign up here</Link>
              </p>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default Login;